enum ZoomMode {
	PAGE = "PAGE",
	WIDTH = "WIDTH",
	HEIGHT = "HEIGHT",
	ORIGINAL = "ORIGINAL",
	CUSTOM = "CUSTOM"
}

export default ZoomMode;